import {memo, useState} from 'react';

import styled from 'styled-components';

import Checkbox from '~/shared/components/Checkbox';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {smallRegular} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';

const StyledCheckbox = styled(Checkbox)`
  .checkbox-rectangle {
    ${flipOnLTR`
      margin-left: 8px;
    `}
  }

  .label-text {
    ${smallRegular}
  }

  .terms_of_service_link {
    color: ${({theme}) => theme.colors.contentLink};

    :hover {
      text-decoration: underline;
    }
  }
`;

type OtlTermsOfUseCheckboxProps = {
  initialValue?: boolean;
  onChange?: (val: boolean) => void;
  className?: string;
};

const OtlTermsOfUseCheckbox = ({onChange, initialValue, className}: OtlTermsOfUseCheckboxProps) => {
  const [isTermsOfUseConfirmed, setIsTermsOfUseConfirmed] = useState(!!initialValue);
  const {t} = getLocalizationService();

  const toggleCheckbox = () => {
    setIsTermsOfUseConfirmed(s => {
      onChange?.(!s);
      return !s;
    });
  };

  return (
    <StyledCheckbox
      className={className}
      value={isTermsOfUseConfirmed}
      onValueChange={toggleCheckbox}
      id="confirm_terms_of_use_checkbox"
      name="confirm_terms_of_use_checkbox"
      // eslint-disable-next-line react/no-danger
      label={<span dangerouslySetInnerHTML={{
        __html: t('i_have_read_and_agreed_to_the_terms_of_service_for_the_ten_bis_unlimited_service'),
      }}
      />}
      isPieCheckboxStyles
      outlined
    />
  );
};

export default memo(OtlTermsOfUseCheckbox);
